import { useMutation } from "@tanstack/react-query";
import { usePlausible } from "next-plausible";
import { SubmitHandler } from "react-hook-form";

import { postNewsletterSignUp } from "@/api/newsletter-sign-up";
import useLocaleHelper from "@/hooks/useLanguageHelper/useLocaleHelper";
import { NewsletterData } from "@/types/types";

import { SubscribePrompt } from "./SubscribePrompt";
import { SubscribeSuccess } from "./SubscribeSuccess";

export const NewsletterBanner = ({ dismiss }: { dismiss: () => void }) => {
  const plausible = usePlausible();
  const { data, mutate, isLoading, isSuccess } =
    useMutation(postNewsletterSignUp);
  const { currentLanguage, currentCountry } = useLocaleHelper();

  const onSubmit: SubmitHandler<NewsletterData> = async (data) => {
    plausible("newsletterBannerSubmit");
    mutate({
      email: data.email,
      language: currentLanguage,
      shop_locale: currentCountry,
    });
  };

  return (
    <>
      {!data && (
        <SubscribePrompt
          onSubmit={onSubmit}
          dismiss={dismiss}
          isLoading={isLoading}
        />
      )}
      {isSuccess && <SubscribeSuccess dismiss={dismiss} />}
    </>
  );
};
